import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, ViewContainerRef } from '@angular/core';
import { PetlService } from '../../../services/petl.service';
import { PetlBaseComponent } from '../petl-base.component';
var PetlValidateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PetlValidateComponent, _super);
    function PetlValidateComponent(_vcr, petlService, cdr) {
        var _this = _super.call(this, _vcr, petlService, cdr) || this;
        _this.petlService = petlService;
        _this.cdr = cdr;
        _this.showIssues = false;
        return _this;
    }
    Object.defineProperty(PetlValidateComponent.prototype, "validationReport", {
        get: function () {
            return this.petlService.validationReport;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlValidateComponent.prototype, "enablePromote", {
        get: function () {
            return (this.validationReport && this.validationReport.validatedRows + this.validationReport.warningRows) > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PetlValidateComponent.prototype, "projectIsTrashable", {
        get: function () {
            var project = this.petlService.project;
            return project && project.lineCount === 0 && project.pointCount === 0;
        },
        enumerable: true,
        configurable: true
    });
    PetlValidateComponent.prototype.promoteData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.petlService.promoteData(this.petlService.project).then(function () {
                            _this.petlService.addProjectToMap(_this.petlService.project);
                        }, function () {
                            _this.petlService.changeView('validate');
                            _this.petlService.promoteErrorOccurred = true;
                            _this.petlService.promoteDataSubmitted = false;
                        })];
                    case 1:
                        _a.sent();
                        this.successLevelText = '';
                        return [2 /*return*/];
                }
            });
        });
    };
    PetlValidateComponent.prototype.toggleShowIssues = function () {
        this.setIssueCssClass();
        this.showIssues = !this.showIssues;
    };
    PetlValidateComponent.prototype.setIssueCssClass = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.service.validationReport.fileIssueList), _c = _b.next(); !_c.done; _c = _b.next()) {
                var row = _c.value;
                if (row.issueList.length) {
                    var firstIssue = row.issueList[0];
                    firstIssue.cssClass = this.getIssueLabelClass(firstIssue);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    PetlValidateComponent.prototype.setSuccessfulLevelText = function () {
        if (this.validationReport) {
            this.successLevelText = this.getSuccessLevelText(this.validationReport.validatedRows, this.validationReport.totalRowsProcessed);
        }
    };
    PetlValidateComponent.prototype.goBackToMapping = function () {
        this.petlService.goBackToMapping();
    };
    PetlValidateComponent.prototype.startOver = function () {
        this.petlService.startOver();
    };
    PetlValidateComponent.prototype.getIssueLabelClass = function (issue) {
        if (issue.type === 'Warning') {
            return 'label-warning';
        }
        else {
            return 'label-danger';
        }
    };
    PetlValidateComponent.prototype.trash = function () {
        this.petlService.deleteProject();
        this.petlService.startOver();
    };
    PetlValidateComponent.prototype.sorter = function (item) {
        if (this.sortIndex === 1) {
            return item.issueList[0].columnName;
        }
        else {
            return item.rowNumber;
        }
    };
    PetlValidateComponent.prototype.getSuccessLevelText = function (validated, total) {
        var good = 0.9;
        var fair = 0.5;
        if (validated === total) {
            return 'Awesome!';
        }
        if (validated / total > good) {
            return 'Looks Good.';
        }
        if (validated / total > fair) {
            return 'Good Enough.';
        }
        if (validated > 0) {
            return 'Ok.';
        }
    };
    return PetlValidateComponent;
}(PetlBaseComponent));
export { PetlValidateComponent };
